import api from '@/api'

const SET_COMPANYS = 'SET_COMPANYS'
const ADD_COMPANY = 'ADD_COMPANY'

const SET_COMPANY = 'SET_COMPANY'
const UNSET_COMPANY = 'UNSET_COMPANY'

export default {
  namespaced: true,

  state () {
    return {
      companies: [],
      currentCompany: null
    }
  },

  getters: {
    companies: (state) => state.companies,
    currentCompany: (state) => state.currentCompany
  },

  mutations: {
    [SET_COMPANYS] (state, data) {
      state.companies = data
    },

    [ADD_COMPANY] (state, data) {
      state.companies.shift(data)
    },

    [SET_COMPANY] (state, data) {
      state.currentCompany = data
    },

    [UNSET_COMPANY] (state) {
      state.currentCompany = null
    }
  },

  actions: {
    async loadCompanies ({ commit }, params = {}) {
      const { data } = await api.companies.list(params)
      commit(SET_COMPANYS, data || [])
    },

    async createCompany ({ dispatch }, payload) {
      const { error } = await api.companies.create(payload)
      const filters = { farm: payload.farm }
      dispatch('loadCompanies', filters)
      return error
    },

    async selectCompany ({ commit }, id) {
      const { data } = await api.companies.getById(id)
      commit(SET_COMPANY, data)
      return data
    },

    async updateCompany ({ commit, dispatch, getters }) {
      const item = getters.currentCompany
      const { error } = await api.companies.updateById(item.id, item)
      const params = { farm: item.farm }
      dispatch('loadCompanies', params)
      if (!error) {
        commit(UNSET_COMPANY)
      }
      return error
    },

    async deleteCompany ({ commit, dispatch, getters }) {
      const item = getters.currentCompany
      await api.companies.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadCompanies', params)
      commit(UNSET_COMPANY)
    },

    closeCompany ({ commit }) {
      commit(UNSET_COMPANY)
    }
  }
}
